// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16uQW","col":"styles_col__9_A6V"};